import { ChevronDown } from "lucide-react";
import React, { useState } from "react";
import { Badge } from "../../../../../components/ui/common/badge";
import { Card, CardContent } from "../../../../../components/ui/common/card";
import { cn } from "../../../../../lib/utils";

interface GateCardProps {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  count?: number;
  children?: React.ReactNode;
  defaultOpen?: boolean;
}

const GateCard: React.FC<GateCardProps> = ({
  icon: Icon,
  title,
  count,
  children,
  defaultOpen = true
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <Card className="tw-overflow-hidden !tw-py-0 tw-gap-0 tw-rounded-md">
      <button
        onClick={() => setOpen(o => !o)}
        className="tw-flex tw-items-center tw-justify-start tw-gap-2 tw-w-full tw-text-left tw-bg-muted/40 hover:tw-bg-none tw-px-4 tw-py-3 tw-border-b"
      >
        <ChevronDown
          className={cn(
            "tw-h-4 tw-w-4 tw-text-muted-foreground tw-transition-transform",
            !open && "-tw-rotate-90"
          )}
        />
        <Icon className="tw-h-5 tw-w-5 tw-text-primary" />
        <span className="tw-font-medium tw-text-base">{title}</span>
        {count !== undefined && (
          <Badge variant="outline" className="tw-text-xs tw-ml-2">
            {count} records
          </Badge>
        )}
      </button>

      {open && <CardContent className="tw-space-y-3 tw-py-4">{children}</CardContent>}
    </Card>
  );
};

export default GateCard;
